import { CuradoApiService, CuradoDataService } from '../services/curado-data.service';
import { FacturasApiService, FacturasDataService } from '../services/facturas-data.service';
import { FletesApiService, FletesDataService } from '../services/fletes-data.service';
import { SalidaApiService, SalidaDataService } from '../services/salida-data.service';
import { TableroApiService, TableroDataService } from '../services/tablero-data.service';
import { TrasladoApiService, TrasladoDataService } from '../services/traslado-data.service';
import { DataSourceBinding, dataSource } from './data-source';

/**
 * Implementaciones reales de los servicios de dominio.
 * Cada change de dominio (`curado-api`, `fletes-api`, `traslado-salida-api`, `asignaciones-api`)
 * reemplaza la implementación provisoria por la conexión a la API.
 * `AsignacionesService` ya consulta la API y se provee en root.
 */
export const REAL_DATA_SOURCES: readonly DataSourceBinding[] = [
  dataSource(TableroDataService, TableroApiService),
  dataSource(TrasladoDataService, TrasladoApiService),
  dataSource(CuradoDataService, CuradoApiService),
  dataSource(SalidaDataService, SalidaApiService),
  dataSource(FletesDataService, FletesApiService),
  dataSource(FacturasDataService, FacturasApiService),
];
